import api from '../api';

export async function fetchToday(telegramId){
  const { data } = await api.get('/api/expenses/today', { params: { telegramId } });
  return data.expenses || [];
}

export async function fetchSummary(telegramId){
  const { data } = await api.get('/api/expenses/summary', { params: { telegramId } });
  return data.summary || {};
}

export async function fetchExpenses(telegramId, params={}){
  const { data } = await api.get('/api/expenses', { params: { telegramId, ...params } });
  return data.expenses || [];
}

export async function fetchCategories(telegramId){
  const { data } = await api.get('/api/expenses/categories', { params: { telegramId } });
  return data.categories || [];
}

export async function createExpense(telegramId, payload){
  const { data } = await api.post('/api/expenses', { telegramId, ...payload });
  return data;
}

export async function deleteExpenseById(id){
  const { data } = await api.delete(`/api/expenses/${id}`);
  return data;
}

export const fetchBalances = async (telegramId, extraParams = {}) => {
  try {
    const { data } = await api.get('/api/expenses/balances', { params: { telegramId, ...extraParams } });
    return data.balances || [];
  } catch (error) {
    console.error('Error fetching balances:', error);
    return [];
  }
};

export const fetchFilteredExpenses = async (telegramId, filters = {}) => {
  try {
    const { data } = await api.get('/api/expenses/filtered', { params: { telegramId, ...filters } });
    return data.expenses || [];
  } catch (error) {
    console.error('Error fetching filtered expenses:', error);
    return [];
  }
};

export async function fetchSmsArchive(telegramId, params={}){
  const { data } = await api.get('/api/expenses/sms-archive', { params: { telegramId, ...params } });
  return data.messages || [];
}

/** Overview KPIs + charts. preset: 7d | month | 30d | 90d | ytd | YYYY — or pass startDate/endDate. */
export async function fetchAnalyticsOverview(telegramId, params = {}) {
  const { data } = await api.get('/api/expenses/analytics', { params: { telegramId, ...params } });
  return data.overview || null;
}
 